import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';

import { VidstackIframePlayerConfig, VidstackIframePlayerEvent } from '../../models/vidstack-iframe-player.model';

@Component({
  selector: 'app-vidstack-iframe-player',
  templateUrl: './vidstack-iframe-player.component.html',
  styleUrls: ['./vidstack-iframe-player.component.scss']
})
export class VidstackIframePlayerComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @ViewChild('playerFrame', { static: true }) playerFrame: ElementRef<HTMLIFrameElement>;

  @Input() config: VidstackIframePlayerConfig;
  @Output() playerEvent = new EventEmitter<VidstackIframePlayerEvent>();

  playerReady = false;
  private iframeReady = false;
  private viewReady = false;
  private iframeReloadSequence = 0;

  ngOnInit(): void {
    window.addEventListener('message', this.handleMessage);
  }

  ngAfterViewInit(): void {
    this.viewReady = true;
    this.sendConfiguration();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.config && !changes.config.firstChange) {
      const previousSourceUrl = changes.config.previousValue?.sourceUrl;
      const currentSourceUrl = changes.config.currentValue?.sourceUrl;
      if (previousSourceUrl !== currentSourceUrl) {
        this.playerReady = false;
        this.reloadIframe();
      }
      this.sendConfiguration();
    }
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.handleMessage);
  }

  pause(): void {
    this.sendCommand('pause');
  }

  private handleMessage = (event: MessageEvent): void => {
    const iframe = this.playerFrame?.nativeElement;
    if (!iframe
      || event.origin !== window.location.origin
      || event.source !== iframe.contentWindow
      || event.data?.channel !== 'aviator-vidstack') {
      return;
    }

    const playerEvent: VidstackIframePlayerEvent = event.data;
    if (playerEvent.eventType === 'iframe-ready') {
      this.iframeReady = true;
      this.sendConfiguration();
      return;
    }

    if (playerEvent.eventType === 'ready') {
      this.playerReady = true;
    }

    this.playerEvent.emit(playerEvent);
  }

  private sendConfiguration(): void {
    if (!this.viewReady || !this.iframeReady || !this.config?.sourceUrl) {
      return;
    }

    const brandColor = this.config.brandColor
      || getComputedStyle(document.documentElement).getPropertyValue('--dw-navbar-bg').trim()
      || '#0a6e38';
    this.playerFrame.nativeElement.contentWindow?.postMessage({
      channel: 'aviator-vidstack',
      command: 'initialize',
      data: {
        ...this.config,
        brandColor
      }
    }, window.location.origin);
  }

  private reloadIframe(): void {
    if (!this.viewReady || !this.playerFrame?.nativeElement) {
      return;
    }

    this.iframeReady = false;
    this.iframeReloadSequence++;
    this.playerFrame.nativeElement.src =
      `/assets/video/vidstack-iframe-player.html?v=20261028-2&reload=${this.iframeReloadSequence}`;
  }

  private sendCommand(command: string, data?: { [key: string]: any }): void {
    if (!this.viewReady || !this.iframeReady) {
      return;
    }

    this.playerFrame.nativeElement.contentWindow?.postMessage({
      channel: 'aviator-vidstack',
      command,
      data
    }, window.location.origin);
  }
}
